import LoopingEllipsis from '@/components/LoopingEllipsis';
import { ConnectIcon } from '@/icons';
import DefaultDialog from '@/components/Dialog/DefaultDialog';

export type BridgeConfirmationDialogProps = {
  onClose: () => void;
};

export default function BridgeConfirmationDialog({
  onClose,
}: BridgeConfirmationDialogProps) {
  return (
    <DefaultDialog
      variant="info"
      icon={<ConnectIcon size="1.375rem" />}
      confirmLabel="Done"
      title={
        <>
          Opening in witMetrics Bridge
          <LoopingEllipsis />
        </>
      }
      message="Nothing happening? If nothing opens within a few seconds, ensure witMetrics Bridge is installed & running on your computer."
      onConfirm={onClose}
      onClose={onClose}
    />
  );
}
